export default () => ({
  user: {},
  token: undefined,
  loginToken: undefined,
  queuedActions: [],
  settings: {}
});
